import { NotificationActionTypeEnum, ReminderConfigurationType } from '@/types/schema';

export const DEFAULT_REMINDER_CONFIG = (reminderConfigs: ReminderConfigurationType[]) => [
  {
    actionType: NotificationActionTypeEnum.AssignContent,
    notifyLearners: false,
    reminderConfigurations: [],
  },
  {
    actionType: NotificationActionTypeEnum.DueDateReminder,
    notifyLearners: false,
    reminderConfigurations: reminderConfigs,
  },
  {
    actionType: NotificationActionTypeEnum.ContentOverdue,
    notifyLearners: false,
    reminderConfigurations: [],
  },
];
